/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OWGameEventMap,
    OWGameEventMapFromJSON,
    OWGameEventMapFromJSONTyped,
    OWGameEventMapToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetOverwolfEventMappingsResponse
 */
export interface GetOverwolfEventMappingsResponse {
    /**
     * 
     * @type {Array<OWGameEventMap>}
     * @memberof GetOverwolfEventMappingsResponse
     */
    eventMappings: Array<OWGameEventMap>;
}

export function GetOverwolfEventMappingsResponseFromJSON(json: any): GetOverwolfEventMappingsResponse {
    return GetOverwolfEventMappingsResponseFromJSONTyped(json, false);
}

export function GetOverwolfEventMappingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOverwolfEventMappingsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventMappings': ((json['eventMappings'] as Array<any>).map(OWGameEventMapFromJSON)),
    };
}

export function GetOverwolfEventMappingsResponseToJSON(value?: GetOverwolfEventMappingsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eventMappings': ((value.eventMappings as Array<any>).map(OWGameEventMapToJSON)),
    };
}


